// extracted by mini-css-extract-plugin
var _1 = "Register_alternateActionButtonContainer__DvUF9";
var _2 = "Register_alternateActionText__ddXxC";
var _3 = "Register_button__4goUB";
var _4 = "Register_checkbox__Qji6o";
var _5 = "Register_checkboxLabel__35ZV2";
var _6 = "Register_checkboxWrapper__t13Ak";
var _7 = "Register_formTitle__xUc0+";
var _8 = "Register_inputLabel__lfTwc";
var _9 = "Register_loginWrapper__CVUgd";
var _a = "Register_logo__m9O1D";
var _b = "Register_message__BYlzt";
var _c = "Register_otherOptions__iz+ZI";
var _d = "Register_otherOptionsLine__7qM9Y";
var _e = "Register_otherOptionsText__qLCxL";
var _f = "Register_otherOptionsTextWrapper__X21pL";
var _10 = "Register_registrationDisabledText__b8GIs";
var _11 = "Register_ssoIcon__Lo6BR";
var _12 = "Register_submitButton__YOY44";
var _13 = "Register_submitButtonIcon__Texqv";
var _14 = "Register_wrapper__kto-m";
export { _1 as "alternateActionButtonContainer", _2 as "alternateActionText", _3 as "button", _4 as "checkbox", _5 as "checkboxLabel", _6 as "checkboxWrapper", _7 as "formTitle", _8 as "inputLabel", _9 as "loginWrapper", _a as "logo", _b as "message", _c as "otherOptions", _d as "otherOptionsLine", _e as "otherOptionsText", _f as "otherOptionsTextWrapper", _10 as "registrationDisabledText", _11 as "ssoIcon", _12 as "submitButton", _13 as "submitButtonIcon", _14 as "wrapper" }
